import React from "react";
import * as FileSaver from "file-saver";
import XLSX from "sheetjs-style";
import { Button } from "react-bootstrap";

const ExportExcel = ({ getExcelData, fileName }) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8";
  const fileExtension = ".xlsx";

  const exportToExcel = () => {
    const excelData = typeof getExcelData === "function" ? getExcelData() : [];

    console.log("excelData export:", excelData);

    if (!excelData || excelData.length === 0) {
      alert("Data export kosong");
      return;
    }

    const ws = XLSX.utils.json_to_sheet(excelData);
    const wb = {
      Sheets: { data: ws },
      SheetNames: ["data"],
    };

    const excelBuffer = XLSX.write(wb, {
      bookType: "xlsx",
      type: "array",
    });

    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, `${fileName}${fileExtension}`);
  };

  return (
    <Button
      variant="btn"
      style={{
        backgroundColor: "green",
        color: "white",
      }}
      onClick={exportToExcel}
    >
      Export to Excel
    </Button>
  );
};

export default ExportExcel;
